/**
 * Created by Ella Ma on 06/12/2020.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, Input } from '@angular/core';
import { GridVisualizationSettings } from '../../../../../tamalelibs/models/tile.model';
import { Subject } from 'rxjs';
import { TamTileSettingsEvents } from '../../../../tam-dashboard/tam-dashboard.model';
import * as _ from 'lodash';

@Component({
    selector: 'tam-tile-grid-setting',
    templateUrl: './tile-grid-setting.component.html',
    styleUrls: ['./tile-grid-setting.component.scss']
})
export class TileGridSettingComponent implements OnInit {

    @Input() config: GridVisualizationSettings;
    @Input() action$: Subject<any>;

    settings = new GridVisualizationSettings();

    constructor() { }

    ngOnInit() {
        if (this.config) {
            // use cloneDeep because a new tile but not finished, should not refrence width tileConfig, such as automaticSizing
            this.settings = _.cloneDeep(this.config);
        }
    }

    updateGridSettions() {
        this.action$.next({
            type: TamTileSettingsEvents.UPDATE_GRID_SETTINGS,
            payload: this.settings
        });
    }

    validate() {
        return true;
    }

    refresh() {
        this.settings.automaticSizing = false;
    }

}
